import React, { useState } from "react";
import { connect } from "react-redux";

import Dialog, { CloseDialog } from "components/Dialog";
import SnackbarAlert from "components/Alert";

import NameStep from "./NameStep";
import TypeStep from "./TypeStep";
import PeopleStep from "./PeopleStep";

import classes from "./style.module.scss";

const CreateOrganizationModal = ({ isOpen, company = "", onClose, onCreated }) => {
    const [dismissed, setDismissed] = useState(false);
    const [step, setStep] = useState("name");
    const [name, setName] = useState(company);
    const [orgType, setOrgType] = useState("");
    const [emails, setEmails] = useState("");
    const [alert, setAlert] = useState({
        open: false,
        message: "",
        anchorOrigin: { vertical: "top", horizontal: "center" },
        direction: "down",
    });

    // company arrives with the user data, after the first render in some flows
    const [prefill, setPrefill] = useState(company);
    if (prefill !== company) {
        setPrefill(company);
        setName(company);
    }

    const trimmedName = name.trim();
    const close = () => {
        setDismissed(true);
        onClose?.();
    };

    return (
        <>
            <Dialog open={isOpen && !dismissed} closeActions={close} classes={{ paperClass: classes.dialogPaper }}>
                <CloseDialog closeActions={close} />
                <div className={classes.dialog}>
                    <h3>Create Organization</h3>
                    {step === "name" && (
                        <NameStep name={name} setName={setName} onCancel={close} onContinue={() => setStep("type")} />
                    )}
                    {step === "type" && (
                        <TypeStep
                            name={trimmedName}
                            orgType={orgType}
                            setOrgType={setOrgType}
                            onBack={() => setStep("name")}
                            onContinue={() => setStep("people")}
                        />
                    )}
                    {step === "people" && (
                        <PeopleStep
                            name={trimmedName}
                            orgType={orgType}
                            emails={emails}
                            setEmails={setEmails}
                            onBack={() => setStep("type")}
                            setAlert={setAlert}
                            onCreated={(orgId) => {
                                close();
                                onCreated?.(orgId);
                            }}
                        />
                    )}
                </div>
            </Dialog>
            <SnackbarAlert
                top={"90%"}
                autoHideDuration={6000}
                onClose={() => setAlert((prev) => ({ ...prev, open: false }))}
                {...alert}
            />
        </>
    );
};

const mapStateToProps = (
    {
        user: {
            reqTeamToCreate = false,
            isEmailConfirmed = true,
            isUserVerified = true,
            userMeta: { company = "" } = {},
        },
    },
    { open = false }
) => ({
    // the email confirmation modal owns the screen until the address is confirmed,
    // and an unverified account cannot own an organization yet
    isOpen: open || (reqTeamToCreate && isEmailConfirmed !== false && isUserVerified !== false),
    company: open ? "" : company,
});

export default connect(mapStateToProps, null)(CreateOrganizationModal);
